const AnalyticsEventNames = {
  /* GENERAL */
  EDIT_PROFILE_NAME: 'ProfilePage_EditProfileName',
  CHANGE_PASSWORD: 'ProfilePage_ChangePassword',
  REJECT_INVITE: 'ProfilePage_RejectInvite',
  ACCEPT_INVITE: 'ProfilePage_AcceptInvite',
  SSO_SETTINGS_UPDATE: 'OrganizationPage_SSOSettingsUpdate',
  CLICK_EDIT_ORG_DETAILS: 'OrganizationPage_ClickEditOrgDetails',
  UPDATE_ORG_DETAILS: 'OrganizationPage_UpdateOrgDetails',
  SAVE_CREDIT_CARD: 'BillingPage_SaveCreditCard',
  DOWNLOAD_INVOICE: 'BillingPage_DownloadInvoice',
  CLICK_ADD_CREDIT_CARD: 'BillingPage_ClickAddCreditCard',
  FILTER_USERS_BY_STATUS: 'UsersPage_FilterUsersByStatus',
  FILTER_USERS_BY_PERMISSION: 'UsersPage_FilterUsersByPermission',
  FILTER_USERS_BY_USER: 'UsersPage_FilterUsersByUser',
  CLICK_INVITE_USER_BUTTON: 'UsersPage_ClickInviteUserButton',
  CLICK_UPLOAD_USERS_LIST: 'UsersPage_ClickUploadUsersList',
  EDIT_USER_NAME: 'UsersPage_EditUserName',
  REMOVE_USER: 'UsersPage_RemoveUser',
  RESEND_INVITE: 'UsersPage_ResendInvite',
  SEND_RESET_PASSWORD_LINK: 'UsersPage_SendResetPasswordLink',
  CREATE_NEW_USER: 'UsersPage_CreateNewUser',
  SEND_INVITE_TO_EXISTING_USER: 'UsersPage_SendInviteToExistingUser',
  CLICK_EXPAND_SUBSCRIPTION_LINK: 'UsersPage_ClickExpandSubscriptionLink',
  UPLOAD_USERS_LIST_GET_STARTED: 'UsersPage_UploadUsersList_GetStarted',
  UPLOAD_USERS_LIST_DOWNLOAD_TEMPLATE: 'UsersPage_UploadUsersList_DownloadTemplate',
  UPLOAD_USERS_LIST_SELECT_FILE: 'UsersPage_UploadUsersList_SelectFile',
  UPLOAD_USERS_LIST_VALIDATE_CSV: 'UsersPage_UploadUsersList_ValidateCsv',
  UPLOAD_USERS_LIST_DOWNLOAD_REPORT: 'UsersPage_UploadUsersList_DownloadReport',
  UPLOAD_USERS_LIST_SUBMIT_FILE: 'UsersPage_UploadUsersList_SubmitFile',
  EXPORT_USERS_LIST: 'UsersPage_ExportUsersList',
  CLICKED_SEND_REMINDERS: 'UsersPage_ClickedSendRemindersButton',
  SENT_REMINDERS: 'UsersPage_SentReminders',
  SENT_REMINDERS_SUBMIT: 'UsersPage_SentRemindersSubmit',
  INVITE_USER_TO_ORG: 'UsersPage_InviteUserToOrg',
  CLICK_CONTACT_US_LINK: 'UsersPage_ClickContactUsInHeader',
  SUBMIT_MODAL: 'UsersPage_SubmitMultipleUsersList',
  UPDATE_USER_PERMISSIONS: 'UsersPage_UpdateUserPermissions',
  OPEN_MENU_ITEM: 'UsersPage_OpenMenuItem',
  ASSIGN_TO_TEAMS: 'UsersPage_AssignToTeams',
  BULK_ASSIGN_TO_TEAMS: 'UsersPage_BulkAssignToTeams',
  REMOVE_INVITE: 'UsersPage_RemoveInvite',
  EXPORT_AUDIT_LOGS: 'UsersPage_ExportAuditLogs',
  EXPORT_ACTIVATION_LINKS: 'UsersPage_ExportActivationLinks',
  COPY_ACTIVATION_LINK: 'UsersPage_CopyActivationLink',
  REMOVE_USERS: 'UsersPage_removeMultipleUsers',
  ENABLE_TEAM_MANAGEMENT: 'TeamsPage_EnableTeamManagement',
  DISABLE_TEAM_MANAGEMENT: 'TeamsPage_DisableTeamManagement',
  RENAME_TEAM: 'TeamsPage_RenameTeam',
  DELETE_TEAM: 'TeamsPage_DeleteTeam',
  CREATE_TEAM: 'TeamsPage_CreateTeam',
  ENTER_USAGE_ANALYTICS_PAGE: 'UsagePage_EnterUsageAnalyticsTab',
  ACCEPT_TERMS: 'SignUpPage_AcceptTerms',
  SUBMIT_SIGNUP_PREPOPULATED: 'SignUpPage_Submit_Prepopulated',
  SUBMIT_STEP_1: 'SignUpPage_SubmitStep1',
  SUBMIT_STEP_2: 'SignUpPage_SubmitStep2',
  SUBMIT_STEP_3: 'SignUpPage_SubmitStep3',
  CLICK_ON_HELP_LINK: 'Header_ClickedOnHelpLink',
  CLOSE_PASSWORD_BANNER: 'Header_ClosePasswordBanner',
  CHANGE_PASSWORD_FROM_BANNER: 'Header_ChangePasswordFromBanner',
  SET_NEW_PASSWORD: 'SetPassword_SetNewPassword',
  GOT_ERROR_SETTING_PASSWORD: 'SetPassword_GotErrorSettingPassword',
  GOT_ERROR_CHANGING_PASSWORD: 'ProfilePage_GotErrorChangingPassword',
  OPEN_USER_UPLOAD_PROGRESS: 'UsersPage_OpenProgressBarModal',
  ONBOARDING_BILLING_FLOW_START_USING_TRUST_API: 'OnboardingBilling_StartUsingTrustApi',
  ONBOARDING_BILLING_FLOW_BILLING_DETAILS_SUBMIT: 'OnboardingBilling_BillingDetailsSubmit',
  ONBOARDING_BILLING_FLOW_CREDIT_CARD_DETAILS_STEP: 'OnboardingBilling_CreditCardDetails',
  ONBOARDING_BILLING_FLOW_PAYMENT_SUBMIT: 'OnboardingBilling_paymentSubmit',
  ONBOARDING_BILLING_FLOW_INIT: 'OnboardingBilling_Init',
  SEARCH_INSIGHTS_DOCS_BANNER_CLICK: 'SearchInsightsDocsBannerClick',
  SEARCH_INSIGHTS_DOCS_BANNER_CLOSE: 'SearchInsightsDocsBannerClose',
};

export default AnalyticsEventNames;
